import { render, staticRenderFns } from "./BuyoutOptionEvent.vue?vue&type=template&id=5b470ac0&"
import script from "./BuyoutOptionEvent.vue?vue&type=script&lang=js&"
export * from "./BuyoutOptionEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports